module.exports = __webpack_public_path__ + "img/feature_1.3ae82727.svg";